import Locale from 'rmc-calendar/lib/locale/pt_BR';
export default Locale;
